import { createFileRoute } from "@tanstack/react-router";
import { CarouselStudio, CF, type Board } from "../features/social-carousel/carousel-studio";

export const Route = createFileRoute("/dakhla-carousel")({
  component: () => <CarouselStudio board={DAKHLA_BOARD} />,
});

const DAKHLA_BOARD: Board = {
  topLabel: "Dakhla · Morocco",
  kicker: "10 experiences",
  coverLead: "Things to do in",
  coverAccent: "Dakhla",
  subtitle:
    "Quad & buggy on the dunes, kite-flat lagoon rides, camel treks and white-dune 4x4 safaris.",
  domain: "majourneys.com",
  items: [
    { title: "Quad Biking in Dakhla", label: "Quad", city: "Dakhla", price: 400, hero: CF("c95453d7-fcd1-4d27-343f-9b3df668a600") },
    { title: "Buggy Ride in Dakhla", label: "Buggy", city: "Dakhla", price: 900, hero: CF("79721139-f702-4836-cb36-fbf96fb76500") },
    { title: "Land Sailing in Dakhla", label: "Activities", city: "Dakhla", price: 600, hero: CF("59c08942-c60e-4c04-e961-fbe848812500") },
    { title: "Camel Ride in Dakhla", label: "Camel", city: "Dakhla", price: 250, hero: CF("db243027-7657-48b5-0676-8857041dd800") },
    { title: "Horse Riding in Dakhla", label: "Horse", city: "Dakhla", price: 300, hero: CF("e85480bb-437f-447e-fb77-2d9e663bb500") },
    { title: "E-Bike Experience in Dakhla", label: "Excursions", city: "Dakhla", price: 350, hero: CF("0a9bc7df-e281-43a8-6c70-20f1b9685500") },
    { title: "Desert Safari in Dakhla", label: "Excursions", city: "Dakhla", price: 450, hero: CF("3685f9ea-db90-4d4e-49f0-5019824f5b00") },
    { title: "Half Day Dune Blanche 4x4 in Dakhla", label: "Excursions", city: "Dakhla", price: 800, hero: CF("72eaecd8-9afe-4064-eec8-5bcb09e0a600") },
    { title: "Grand Tour Imlili & Dune Blanche 4x4", label: "Excursions", city: "Dakhla", price: 1400, hero: CF("0852e916-8beb-46c2-1248-abe42de96e00") },
    { title: "Sbita Desert 4x4 Excursion in Dakhla", label: "Excursions", city: "Dakhla", price: 1700, hero: CF("6cbf81d6-5a57-46d4-8432-96f627a61c00") },
  ],
};
